import { ItemType } from '@mimir/common/dto/itemTypes';
import type { PremiereClipInfo } from './premiereTypes';

export function proxyArtifactSupported(clipInfo: PremiereClipInfo) {
  return clipInfo.artifactRef?.type == 'TsSegmentRange' || clipInfo.mimirItem?.itemType == ItemType.VIDEO;
}
